import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { PageTypeRolesInteractions } from './partials/PageTypeRolesInteractions';
import { PageTypeRolesBlockDefaultView } from './views/PageTypeRolesBlockDefaultView';
import { PageTypeRolesBlockEditView } from './views/PageTypeRolesBlockEditView';
import { useAppContext } from '../../contexts/AppContext/AppContext';

export type PageTypeRolesProps = Views<
  DefaultView<PageTypeRolesBlockDefaultView> & OptionalEditView<PageTypeRolesBlockEditView>
>;

function PageTypeRoles({ views, activeView }: PageTypeRolesProps) {
  const { editModeInfo } = useAppContext();

  if (editModeInfo.active) {
    return <PageTypeRolesInteractions views={views} activeView={activeView} />;
  }

  return <PageTypeRolesBlockDefaultView {...views.default} additionalProps={{ headingHierarchy: 3 }} />;
}

export const PageTypeRolesBlock = asFetchableBlock(PageTypeRoles, BlockType.pagetyperoles);
export type PageTypeRolesBlock = ComponentProps<typeof PageTypeRolesBlock>;
